function SwapParkingBannerAndFormAndHideAlert() {
    if ($(window).width() <= 730) {
        $('.header-alert').addClass('hide-on-mobile');
        $('.parking-form-content').insertBefore($('.parking-header-content'));
        setupDatePickers();
    } else {
        $('.header-alert').removeClass('hide-on-mobile');
        $('.parking-header-content').insertBefore($('.parking-form-content'));
        setupDatePickers();
    }
}

$(document).ready(function () {
    /*
    SwapParkingBannerAndFormAndHideAlert();
    $(window).on('resize', function () {
        SwapParkingBannerAndFormAndHideAlert();
    });
    */
});